import { IDriver } from "@/types/IDriver"
import { ITransport, ITransportClass } from "@/types/ITransport"

export const EMPTY_DATA = "-"

export const formatDriver = (driver?: IDriver) => {
  return `${driver?.fullName ?? ""}`
}

export const formatTransport = (transport?: ITransport) => {
  if (!transport)
    return ""

  const liter = transport.class === ITransportClass.Truck ? ""
    : `, ${transport.liter ?? "не установлено"} Л`

  return `${transport.number} ${transport.region}${liter}, ${transport.model}`
}

export const formatNulableValue = (value: string | null | undefined) => {
  return value ? (value ?? EMPTY_DATA) : EMPTY_DATA
}

export const formatLongStringValue = (value: string | null | undefined, maxlen: number = 80) => {
  const maxVisibaleLen = maxlen
  const moreDots = "..."

  return !value ?
    formatNulableValue(value) :
    value?.length > maxVisibaleLen ? value.substring(0, maxVisibaleLen) + moreDots : value
}
